export default __webpack_public_path__ + "static/media/mastercard.f18d0048.svg";